export default "__VITE_ASSET__BnsX0nu8__"